﻿import angular from "angular";

import DateExtended from "serviceJs/date.service.ts";

import "./datastorage";

angular.module("folkeuni").factory("Favorites", function (DataStorage, $q, $rootScope) {
    var self = this,
        favorites = null;

    var _formatEvent = function (list) {
        if (list) {
            for (var i = 0; i < list.length; i++) {
                var item = list[i];
                // Set endDate formatted
                if (item.endDate) {
                    item.endDateFormatted = new DateExtended(item.endDate).format("[DD].[MM].[YYYY]");
                }
                // Set startDate formatted
                if (item.startDate) {
                    item.startDateFormatted = new DateExtended(item.startDate).format("[DD].[MM].[YYYY]");
                }

                // Set expired bool
                item.expired = false;
                try {
                    if (item.endDate) {
                        var currentDate = new Date();
                        var eventDate = new Date(item.endDate);
                        if (currentDate > eventDate) {
                            item.expired = true;
                        }
                    }
                } catch (ex) {}
            }
        }
        return list;
    };

    self.getFavorites = function () {
        var deferred = $q.defer();

        DataStorage.get("favoriteList").then(
            function (data) {
                const favoriteList = JSON.parse(data);

                deferred.resolve(_formatEvent(favoriteList));
            },
            function () {
                deferred.resolve([]);
            }
        );

        return deferred.promise;
    };

    self.setFavorites = function (list) {
        var deferred = $q.defer();

        if (list) {
            DataStorage.set("favoriteList", JSON.stringify(list)).then(
                function () {
                    deferred.resolve(_formatEvent(list));
                },
                function () {
                    deferred.reject();
                }
            );
        } else {
            deferred.reject();
        }

        return deferred.promise;
    };

    self.isFavorite = function (id) {
        var deferred = $q.defer();
        var exists = false;

        if (id) {
            DataStorage.get("favoriteList").then(
                function (data) {
                    var list = JSON.parse(data);

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].id === id) {
                            exists = true;
                            break;
                        }
                    }
                    deferred.resolve(exists);
                },
                function () {
                    deferred.resolve(exists);
                }
            );
        } else {
            deferred.resolve(exists);
        }

        return deferred.promise;
    };

    self.removeAsFavorite = function (id) {
        var deferred = $q.defer();

        if (id) {
            DataStorage.get("favoriteList").then(
                function (data) {
                    var list = JSON.parse(data);

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }

                    DataStorage.set("favoriteList", JSON.stringify(list)).then(
                        function () {
                            deferred.resolve(_formatEvent(list));
                        },
                        function () {
                            deferred.reject();
                        }
                    );
                },
                function () {
                    deferred.reject();
                }
            );
        } else {
            deferred.reject();
        }

        return deferred.promise;
    };

    return self;
});
